import { render, staticRenderFns } from "./SelectDocumentsModal.vue?vue&type=template&id=e60cf3f4"
import script from "./SelectDocumentsModal.vue?vue&type=script&lang=js"
export * from "./SelectDocumentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports